import React from "react";
import "../../assets/css/container/main/AboutFactWeb.css";

export default function AboutFactWeb() {
	return (
		<div className="about-container">
			<h1 className="about-title">팩트체크 FactWeb</h1>

			<section className="about-section">
				<h2>FactWeb은</h2>
				<p>
					FactWeb은 수많은 주장과 의견 속에서 사실에 근거한 판단을 돕기 위해 만들어진
					<b> 팩트체크·사실검증 중심의 토론 플랫폼</b>입니다.
					누구나 자신의 주장을 제시하고, 다른 사용자들과 함께 팩트를 기준으로 검증하며
					건전한 토론 문화를 만들어갈 수 있습니다.
				</p>
			</section>

			<section className="about-section">
				<h2>서비스 소개</h2>
				<p>
					FactWeb에서는 사용자가 직접 작성한 글과 댓글을 바탕으로
					긍정·부정·중립의 관점에서 의견을 나누고,
					팩트체크 과정을 통해 다양한 시각을 한눈에 확인할 수 있습니다.
					이를 통해 특정 주장에 대한 사회적 인식과 판단 흐름을
					통계적으로 살펴볼 수 있습니다.
				</p>
			</section>

			<section className="about-section">
				<h2>FactWeb이 추구하는 가치</h2>
				<p>
					FactWeb은 가짜뉴스와 왜곡된 정보가 아닌,
					<b>사실과 근거에 기반한 정보 공유</b>를 최우선으로 합니다.
					서로 다른 의견이 존중받되, 팩트 앞에서는 누구나 검증받는
					건강한 온라인 공론장을 지향합니다.
				</p>
			</section>

			<section className="about-section">
				<h2>회사 정보</h2>
				<p>
					<b>회사명:</b> 팩트웹IT <br />
					<b>이메일:</b> firefk4@gmail.com <br />
					<b>카카오 오픈채팅방:</b>{" "}
					<a
						href="https://open.kakao.com/o/ggUdJ3Th"
						target="_blank"
						rel="noopener noreferrer"
					>
						참여하기
					</a>
				</p>
			</section>
		</div>
	);
}
